import ProductCard from "./ProductCard/ProductCard";
import Ripple from "../../ui/spinners/ripple/Ripple";
import Pagination from "../Pagination/Pagination";
import noItems from "../../../assets/images/noItems.jpg";
import RequestNewSkuModal from "../../ui/Modal/requestNewSkuModal/RequestNewSkuModal";
import { useState } from "react";
import PackageIcon from "../../../ui/PackageIcon";
import { useSearchParams } from "react-router-dom";

const ProductsGrid = ({
  categoryId,
  categoryName,
  subCategories,
  skus,
  productsLoading,
  subCategoriesLoading,
  total,
  limit,
  currentPage,
  setCurrentPage,
  changePage,
  filterSkus,
  noPagination,
}) => {
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [skuNameList, setSkuNameList] = useState([]);
  const [searchParams] = useSearchParams();

  const selectedSkuNameIdFromFilter = Number(searchParams.get("skuNameIdList"));
  const initialSkuNameFromFilter = skuNameList?.find(
    ({ skuNameId }) => skuNameId === selectedSkuNameIdFromFilter
  );

  const handleCloseRequest = () => {
    setShowRequestModal(false);
  };

  const handleOpenRequest = () => {
    setShowRequestModal(true);
  };

  // filter products by subcategory
  const filterBySubCategory = (subCategoryId, skuNameList) => {
    if (subCategoryId === "all") {
      filterSkus({ subCategoryId: null, skuNameIdList: null });
      setSkuNameList([]);
    } else {
      filterSkus({ subCategoryId, skuNameIdList: null });
      setSkuNameList(skuNameList);
    }
  };

  // filters buttons
  const subCategoriesFilters =
    subCategories &&
    subCategories.map((subCategory) => (
      <button
        key={subCategory.subCategoryId}
        onClick={() =>
          filterBySubCategory(
            subCategory.subCategoryId,
            subCategory.skuNameList
          )
        }
        className={[
          "py-3",
          "px-4",
          "border",
          "border-light-gray",
          "rounded-lg",
          Number(searchParams.get("subCategoryId")) ===
          subCategory.subCategoryId
            ? "bg-dark-blue text-white"
            : "",
        ].join(" ")}
      >
        {subCategory.subCategoryName}
      </button>
    ));

  // skus cards
  const skusCards =
    skus && skus.map((sku) => <ProductCard key={sku.id} sku={sku} />);

  let content;
  if (productsLoading) {
    content = <Ripple className="border-dark-blue" />;
  } else if (skus?.length === 0) {
    content = (
      <div className="mx-auto w-fit text-center">
        <img src={noItems} alt="no items match your filters" />
        <h2>لا توجد عناصر تطابق عوامل التصفية الخاصة بك</h2>
        <button
          className="px-4 py-2 rounded-lg bg-dark-blue text-white text-center mt-4 hover:opacity-70 flex justify-center items-center gap-2"
          onClick={handleOpenRequest}
        >
          <PackageIcon color={"#fff"} /> اضف منتج الي قائمة المنتجات المطلوبة{" "}
        </button>
      </div>
    );
  } else {
    content = (
      <>
        <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {skusCards}
          <div
            dir="ltr"
            className="mt-6 col-span-full max-w-full overflow-x-auto"
          >
            {!noPagination && (
              <Pagination
                total={total}
                limit={limit}
                currentPage={currentPage}
                changePage={changePage}
                setCurrentPage={setCurrentPage}
              />
            )}
          </div>
        </section>
      </>
    );
  }
  return (
    <div className="flex flex-col grow relative">
      {categoryName && (
        <div className="flex justify-between items-center">
          <h3 className="mb-3.5"> {categoryName}</h3>
          <button
            className="px-4 py-2 rounded-lg bg-dark-blue text-white text-center  disabled:bg-light-gray disabled:cursor-not-allowed hover:opacity-70 flex justify-center items-center gap-2"
            onClick={handleOpenRequest}
          >
            <PackageIcon color={"#fff"} /> اضف منتج الي قائمة المنتجات المطلوبة{" "}
          </button>
        </div>
      )}

      {categoryId ? (
        <ul className="mb-6 flex flex-wrap gap-4">
          {subCategoriesLoading ? (
            <Ripple className="border-dark-blue" />
          ) : (
            <>
              <li
                onClick={() => filterBySubCategory("all")}
                role="button"
                className={[
                  "py-3",
                  "px-4",
                  "border",
                  "border-light-gray",
                  "rounded-lg",
                  Number(searchParams.get("subCategoryId"))
                    ? ""
                    : "bg-dark-blue text-white",
                ].join(" ")}
              >
                الكل
              </li>
              {subCategoriesFilters}
            </>
          )}
        </ul>
      ) : null}

      <div className="flex flex-wrap gap-2 mb-4">
        {skuNameList &&
          skuNameList.map(({ skuName, skuNameId }) => (
            <button
              key={skuNameId}
              onClick={() => filterSkus({ skuNameIdList: skuNameId })}
              className={[
                "py-3 px-4 border border-2 border-green-600 rounded-lg",
                Number(searchParams.get("skuNameIdList")) === skuNameId
                  ? "bg-emerald-400"
                  : "",
              ].join(" ")}
            >
              {skuName}
            </button>
          ))}
      </div>

      {content}

      {showRequestModal && (
        <RequestNewSkuModal
          closeModal={handleCloseRequest}
          initialSkuNameId={
            Number.isFinite(selectedSkuNameIdFromFilter) &&
            selectedSkuNameIdFromFilter > 0
              ? selectedSkuNameIdFromFilter
              : null
          }
          initialSkuName={
            initialSkuNameFromFilter
              ? {
                  id: initialSkuNameFromFilter.skuNameId,
                  skuName: initialSkuNameFromFilter.skuName,
                }
              : null
          }
        />
      )}
    </div>
  );
};

export default ProductsGrid;
